'use strict'
import smoothscroll from 'smoothscroll-polyfill';
// A sample component

const TeamMemberPopin = {
    init: function () {
        if (document.querySelector('.team-member-details__container')) {
            this.addMarkupToList();
        }
    },
    addMarkupToList: function () {
        const teamList = document.querySelector('.js-team-list');
        const teamItems = document.querySelectorAll('.js-team-item');
        const itemPerLine = 4;

        for (let i = 0; i < teamItems.length; i++) {
            const element = teamItems[i];
            let markupMemberDetails
            element.addEventListener('click', (e) => {
                if (e.target.classList.contains('js-open-popin')) {
                    // Find position for create LI popin
                    let clickedElRowNumber = Math.ceil((i + 1) / itemPerLine);
                    let positionCreateElement = clickedElRowNumber * itemPerLine;
                    // create LI element with content of the clicked element
                    markupMemberDetails = element.querySelector('.team-member-details__container').cloneNode(true);
                    const createElement = () => {
                        const li = document.createElement("LI");
                        li.classList.add('member-details-popin');
                        li.appendChild(markupMemberDetails);
                        teamList.insertBefore(li, teamList.children[positionCreateElement]);

                        if (window.innerWidth > 991) {
                            setTimeout(() => {
                                smoothscroll.polyfill();
                                const y = li.getBoundingClientRect().top + window.pageYOffset - 100;
                                window.scrollTo({ top: y, behavior: 'smooth' });
                            }, 100);
                        }

                        // Remove Element with animation on close 
                        const closePopin = li.querySelector('.js-close-popin');
                        li.style.height = li.clientHeight + "px";
                        closePopin.addEventListener('click', () => {
                            li.style.height = "0px";
                            li.style.opacity = 0;
                            li.addEventListener('transitionend', () => {
                                li.remove();
                            })
                        })
                    }
                    if (!teamList.querySelector('.member-details-popin')) {
                        createElement();
                    } else {
                        teamList.querySelector('.member-details-popin').remove();
                        createElement();
                    }
                }
            })
        }
    },
}

export default TeamMemberPopin;
